// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");

function lazyPromiseToReludeIO(lazyPromise) {
  return Curry._2(Relude_IO.mapError, (function (prim) {
                return prim;
              }), Relude_Js_Promise.toIOLazy(lazyPromise));
}

exports.lazyPromiseToReludeIO = lazyPromiseToReludeIO;
/* Relude_IO Not a pure module */
